import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './error-boundary.less';

/**
 * Generic React error boundary.
 */
class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: null,
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  componentDidCatch(error) {
    // Log to newrelic
    if (_.has(window, 'newrelic.noticeError')) {
      window.newrelic.noticeError(error, {
        errorType: 'Error Boundary',
      });
    }
  }

  /**
   * Browswer refresh page onClick
   */
  onClick = () => {
    location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='errorBoundary'>
          <p>
            Uh oh, something went wrong. Please
            <button className='button text reloadButton' href='#' onClick={this.onClick}>
            reload the page.
            </button>
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./app/common/components/error-boundary.jsx